import React from "react";

export default function Experience(){
  return (
    <section id="experience" className="section container">
      <h2 className="section-title">EXPERIENCE</h2>
      <div className="exp">
        <div>
          <h3>Systems Engineer - React JS Developer</h3>
          <p className="muted">Tata Consultancy Services — MARCH 2021 - JULY 2025</p>
          <ul>
            <li>Developed dynamic, high-performance applications using React JS with functional components and advanced Hooks (useState, useEffect, useContext, useReducer) to improve maintainability and performance.</li>
<li>Built responsive, cross-browser UIs using HTML5, CSS3, Flexbox, Grid, and CSS variables for clean and scalable layouts.</li>
<li>Implemented component-based architecture, creating reusable, modular, and testable UI components for faster development and consistent design.</li>
<li>Led a team in Agile (Scrum/Kanban) environments — managing sprints, hosting stand-ups, and prioritizing tasks using Jira.</li>
<li>Streamlined collaboration with Git, GitHub, GitLab, managing branches, resolving merge conflicts, and handling pull/merge requests efficiently.</li>
<li>Effectively managed global state using Redux, implementing scalable patterns for complex workflows and asynchronous operations.</li>
<li>Worked closely with backend teams integrating APIs using Axios, validating endpoints with Postman, and debugging with Chrome DevTools to improve reliability.</li>
<li>Coptimized front-end performance with lazy loading, minimizing load times and improving page responsiveness.</li>
<li>Collaborated directly with clients and stakeholders, gathering requirements, addressing feedback, and ensuring UI deliverables aligned with business goals.</li>            
          </ul>
        </div>
      </div>
    </section>
  );
}